import { UseFormReturn } from 'react-hook-form'
import { Form } from './ui/Form'
import { FormValues } from './ui/Form/model'

type BasicInformationStepProps = {
  onSuccess: (formValues: FormValues, captchaToken: string) => void
  form: UseFormReturn<FormValues>
  isSubmitting: boolean
}

export function BasicInformationStep({
  onSuccess,
  form,
  isSubmitting,
}: BasicInformationStepProps) {
  return <Form onSuccess={onSuccess} form={form} isSubmitting={isSubmitting} />
}
